import * as _ from "lodash";
import * as React from "react";
import * as Models from "../../../Models";
import DataGrid from "../DataGrid";
import {
    getItemGroupData,
    createChildRows,
    withExpander,
} from "../../../Helpers/availableServicesTable";
import GroupedDataGrid from "../DataGrid/GroupedDataGrid";

interface IAvailableServicesItemGroupProps {
    attributeGroup: Models.AttributeGroup;
}

export default function AvailableServicesItemGroup(
    props: IAvailableServicesItemGroupProps
) {
    function getDataGridContent(
        headers: string[],
        rows: Models.GroupedAttributeRow[]
    ): Models.DataGridContent {
        const result: Models.DataGridContent = getItemGroupData(headers, rows);
        return result;
    }

    const rows: Models.GroupedAttributeRow[] = props.attributeGroup
        ? createChildRows(props.attributeGroup.rows)
        : [];

    const headers: string[] = props.attributeGroup.headers;

    const dataGridContent: Models.DataGridContent = withExpander(
        getDataGridContent(headers, rows)
    );

    return (
        <div className="ItemGroup full-width">
            <h3 className="ItemGroup__title">
                <div>
                    <span>{props.attributeGroup.name}</span>
                </div>
            </h3>

            <GroupedDataGrid
                filterable={dataGridContent.data.length > 10}
                isSortable={true}
                showPagination={false}
                content={dataGridContent}
                hideHeader={headers.length === 0}
                subComponent={getSubComponent(props)}
            />
        </div>
    );

    function getSubComponent(
        props: IAvailableServicesItemGroupProps
    ): (row: any) => JSX.Element {
        return (row: any) => {
            return (
                row.original.children && (
                    <div className={"ItemGroup__grouprowsubcomponent"}>
                        <DataGrid
                            filterable={false}
                            showPagination={false}
                            hideHeader={true}
                            content={getItemGroupData(
                                props.attributeGroup.headers,
                                row.original.children,
                                ["Number Of Available Services"]
                            )}
                            isSortable={false}
                        />
                    </div>
                )
            );
        };
    }
}
